import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AdditionalBathroomIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AdditionalBathroomIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.7797 12.5455C21.7797 12.2764 21.5615 12.0583 21.2926 12.0583H5.16576V10.0645H6.69689V10.9742C6.69689 11.2432 6.9151 11.4614 7.18464 11.4614C7.45358 11.4614 7.67179 11.2432 7.67179 10.9742V9.57729C7.67179 9.30822 7.45358 9.09009 7.18464 9.09009H4.67859C4.40965 9.09009 4.19145 9.30822 4.19145 9.57729V12.0583H2.70737C2.43843 12.0583 2.22021 12.2764 2.22021 12.5455C2.22021 15.6042 4.05881 18.2413 6.68834 19.4108L6.53858 19.4735C6.2898 19.5773 6.17305 19.8627 6.27697 20.1109C6.35459 20.2979 6.53552 20.4104 6.72622 20.4104C6.7892 20.4104 6.85275 20.3982 6.91387 20.3726L8.1009 19.8765C8.62534 19.993 9.17056 20.0549 9.72983 20.0549H14.2701C14.9327 20.0549 15.5751 19.9683 16.1875 19.8064L17.542 20.3726C17.6038 20.3983 17.6673 20.4104 17.7297 20.4104C17.9204 20.4104 18.1013 20.2977 18.1795 20.1109C18.2835 19.8627 18.1661 19.5773 17.9179 19.4735L17.528 19.3106C20.042 18.0953 21.7797 15.5195 21.7797 12.5455ZM14.2701 19.0805H9.72983C6.28981 19.0805 3.46224 16.4095 3.21224 13.0326H20.7871C20.5371 16.4095 17.7095 19.0805 14.2701 19.0805Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.1772 5.00823C14.6806 4.9563 14.1881 4.84468 13.7148 4.67814C13.2826 4.52533 12.8648 4.32537 12.4726 4.08362C12.1813 3.90455 11.8202 3.90514 11.5277 4.08302C11.1361 4.32477 10.7183 4.52533 10.2861 4.67814C9.81215 4.84468 9.31971 4.9563 8.82308 5.00823C8.36107 5.05658 8.01308 5.44278 8.01367 5.90658V7.90921C8.01427 9.49579 8.8762 10.96 10.2628 11.7312L11.5599 12.4517C11.6936 12.5263 11.8452 12.5663 11.9992 12.5669H12.0016C12.155 12.5663 12.306 12.5263 12.4386 12.4529L13.7386 11.7312C15.1246 10.9594 15.9866 9.49519 15.9872 7.90921V5.90658C15.9872 5.44278 15.6392 5.05658 15.1772 5.00823ZM10.766 10.8245C9.70771 10.2366 9.05052 9.11914 9.04992 7.90921V6.02596C9.58594 5.9603 10.1178 5.83614 10.6317 5.65528C11.1075 5.48695 11.5671 5.27027 11.9998 5.00943C12.4332 5.26968 12.8934 5.48696 13.3692 5.65528C13.8813 5.83555 14.4114 5.9597 14.9504 6.02536V7.9092C14.9498 9.11973 14.2926 10.2365 13.2349 10.8245L11.9999 11.5103L10.766 10.8245Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.5904 7.67518L13.637 7.63399C13.8298 7.42328 13.8154 7.09498 13.6053 6.90218C13.5032 6.80847 13.3677 6.75415 13.2322 6.76668C13.0944 6.77265 12.9666 6.83234 12.8747 6.93202L11.7746 8.10554L11.2839 7.6692C11.0702 7.48117 10.7437 7.50087 10.5545 7.71277C10.462 7.81604 10.4154 7.94915 10.4232 8.08703C10.4316 8.22551 10.4924 8.35265 10.5963 8.44458L11.4642 9.21698C11.5597 9.30055 11.6815 9.34651 11.8074 9.34651C11.9507 9.34651 12.0892 9.28682 12.1853 9.18296L13.5904 7.67518Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default AdditionalBathroomIcon;
